import React__default, { useState } from 'react';
import clsx from 'clsx';
import { cssChipV2 } from './ChipV2.css.js';

const renderIcon = (chipId, iconData, position) => {
    const id = `${chipId || 'chip'}-icon-${position}`;
    if (!iconData) {
        return null;
    }
    // iconData, as string, means icons from https://thermoux.s3.amazonaws.com/komodo-icons.css
    if (typeof iconData === 'string') {
        return React__default.createElement("span", { id: id, "data-testid": id, className: `${iconData} ${`c-chip__icon-${position}`}` });
    }
    return iconData;
};
const ChipV2 = (props) => {
    const { id, size = 'medium', className, label = '', selected = false, disabled = false, closable = false, leftIcon = undefined, rightIcon = undefined, tabIndex, onClick, onClose, ...rest } = props || {};
    const [closed, setClosed] = useState(false);
    const onClickCloseButton = (e) => {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setClosed(true);
        return onClose?.(props);
    };
    const onMouseDown = (e) => {
        // prevent mouse down default so we don't focus on click.
        // Focus (if applicable) will be done via tab index
        e.preventDefault();
    };
    const chipProps = {
        id,
        className: clsx({
            'c-chip': true,
            'c-chip--choice': size === 'medium',
            'c-chip--choice-small': size === 'small',
            'c-chip__close': closed,
            'c-chip--active': selected
        }, className),
        disabled,
        onMouseDown,
        onClick: (e) => onClick?.(props, e),
        ...rest
    };
    if (closed) {
        return null;
    }
    return (React__default.createElement("div", { className: `chip-wrapper ${cssChipV2}`, tabIndex: tabIndex },
        React__default.createElement("div", { "data-testid": id, ...chipProps },
            renderIcon(id, leftIcon, 'left'),
            React__default.createElement("span", { className: 'c-chip__text' }, label),
            renderIcon(id, rightIcon, 'right'),
            closable && (React__default.createElement("span", { "data-testid": `${id || 'chip'}-close`, onClick: onClickCloseButton, className: 'c-chip__close' }, "\u2715")))));
};

export { ChipV2, ChipV2 as default };
//# sourceMappingURL=ChipV2.js.map
